<template>
    <md-dialog md-open-from="#billingHistory" md-close-to="#billingHistory" ref="billingHistory" @open="fixContent" @close="startOver" class="billing-history-modal">
        <md-dialog-title>
            <div class="modal-title">Billing History</div>
        </md-dialog-title>
        <md-dialog-content class="billing-history-modal-content">
            <md-layout class="billing-history-table-content">
                <table class="billing-history-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Description</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="invoice in invoices" :key="invoice.id">
                            <td>{{invoice.date}}</td>
                            <td>{{invoice.amount}}</td>
                            <td>{{invoice.description}}</td>
                            <td class="invoice-cell-status">{{invoice.status}}</td>
                        </tr>
                    </tbody>
                </table>
            </md-layout>
        </md-dialog-content>
    </md-dialog>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { GET_INVOICES_URL } from '@/lib/URLs';

export default {
    name: 'billingHistory',
    data: function() {
        return {
            invoices: []
        };
    },
    computed: {
        ...mapGetters([
            'user',
            'showMode'
        ])
    },
    methods: {
        open() {
            this.$refs.billingHistory.open();
        },
        closeDialog() {
            this.$refs.billingHistory.close();
        },
        fixContent() {
            this.opened = true;
            this.doing = true;
            this.invoices = [];
            Vue.http.post(GET_INVOICES_URL, {
                customer: this.user.stripe_id
            }).then(({data: response}) => {
                this.invoices = response.data.map(invoice => ({
                    date: moment(invoice.created * 1000).format('MMM Do YYYY'),
                    amount: '$' + (invoice.total / 100).toFixed(2),
                    description: '',
                    status: invoice.status
                })) || [];
                this.doing = false;
            }).catch(() => {
                this.doing = false;
            });
            Vue.material.setCurrentTheme(this.showMode ? 'show-mode' : 'default');
        },
        startOver() {
            this.opened = false;
            Vue.material.setCurrentTheme(this.showMode ? 'show-mode' : 'default');
        },
        cancel() {
            this.$refs.billingHistory.close();
        }
    }
};
</script>

<style lang="scss">
.billing-history-modal {
    .md-dialog {
        min-width: 640px;
        max-width: 1024px;
    }
    .md-dialog-title {
        background: #081e4f;
        font-size: 40px;
        line-height: 1.4;
        text-align: center;
        color: white;
        padding: 1rem;
    }
    .billing-history-modal-content {

        padding: 0 1rem 1rem;

        .billing-history-table-content {
            width: 100%;
            height: 100%;
        }

        .billing-history-table {
            width: 100%;
            border: 0 none;
            border-collapse: collapse;

            thead th, tbody td {
                border: solid 1px #ccc;
                font-size: 11px;
                padding: 4px;
                cursor: default;
                white-space: nowrap;
            }
            thead th {
                background: #164e7d;
                color: #fff;
                text-transform: uppercase;
            }
            tbody td {
                max-width: 400px;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            tbody td.invoice-cell-status {
                text-transform: capitalize;
            }
        }
    }
    .md-error {
        color: #e5424d;
        font-size: 12px;
    }
}
</style>


// WEBPACK FOOTER //
// billing-history.vue?1f3d3307